import { getScrollParent } from '~/common/helpers/scroll_parent'
import { Controller } from 'stimulus'
import $ from 'jquery'

let lastSelectionText

document.addEventListener('mousedown', () => {
  lastSelectionText = window.getSelection()?.toString()
})

export default class extends Controller {
  static targets = ['modalBodySlot']

  // We do this w/ JS instead of firing a new request that loads the modal for a much nicer/faster UX
  showPost(event) {
    if (event.metaKey) return
    event.preventDefault()
    const currentSelection = window.getSelection()?.toString() || ''
    const lastSelection = lastSelectionText || ''
    if (currentSelection && currentSelection != lastSelection) return
    if (this.modalBodySlotTarget.contains(event.target)) return

    const post = event.target.closest('.js-post-container')
    post.querySelector('.js-new-indicator')?.remove()

    const postClone = post.cloneNode(true)

    postClone
      .querySelectorAll('template[data-untemplate-when-in-feed-modal]')
      .forEach((el) => {
        const templateHTML = el.innerHTML
        el.insertAdjacentHTML('afterend', templateHTML)
        el.remove()
      })

    postClone
      .querySelectorAll('[data-remove-when-in-feed-modal]')
      .forEach((el) => {
        el.remove()
      })

    querySelectorAllIncludingSelf(
      postClone,
      '[data-classes-to-remove-when-in-feed-modal]'
    ).forEach((el) => {
      el.classList.remove(
        ...el.dataset.classesToRemoveWhenInFeedModal.split(' ')
      )
    })

    querySelectorAllIncludingSelf(
      postClone,
      '[data-classes-to-add-when-in-feed-modal]'
    ).forEach((el) => {
      el.classList.add(...el.dataset.classesToAddWhenInFeedModal.split(' '))
    })

    this.modalBodySlotTarget.replaceChildren(postClone)
    $(this.modalBodySlotTarget).changed()
    this.stackCommentBarBelowHeader()

    this.dispatch('modal:show', {
      target: this.modalBodySlotTarget,
      prefix: false,
    })

    this.dispatch('recordView', {
      detail: { type: 'ForumPost', id: post.dataset.id, opened: true },
    })

    this.resetModalScroll()
  }

  showPostComments(event) {
    if (this.modalBodySlotTarget.contains(event.target)) return
    this.showPost(event)
    const commentsId = event.currentTarget.getAttribute('href')
    // The feed keeps a comments preview with the same id, which has no paginator, so look inside the modal's copy.
    const comments = this.modalBodySlotTarget.querySelector(commentsId)
    comments.querySelector('.js-comments-paginator').style.minHeight = '50vh'
    this.resetModalScroll()
    comments.scrollIntoView()
    comments.addEventListener('cursor-paginator:loadComplete', () => {
      comments.querySelector('.js-comments-paginator').style.minHeight = ''
    })
  }

  resetModalScroll() {
    const scrollParent = getScrollParent(this.modalBodySlotTarget)
    scrollParent.scrollTop = 0
    void scrollParent.offsetWidth
  }

  // The post header and the comment bar both stick to the top of the modal, so once the thread scrolls the bar covers the
  // header's menus. Sticking the bar under the header keeps both reachable; the header's height can change, so track it.
  stackCommentBarBelowHeader() {
    this.headerResizeObserver?.disconnect()
    const header = this.modalBodySlotTarget.querySelector('.js-post-header')
    const commentBar = this.modalBodySlotTarget.querySelector('.js-comment-bar')
    if (!header || !commentBar) return

    this.headerResizeObserver = new ResizeObserver(() => {
      commentBar.style.top = `${header.offsetHeight}px`
    })
    this.headerResizeObserver.observe(header)
  }

  modalHidden() {
    this.headerResizeObserver?.disconnect()
    // Make sure things inside modal like video/audios etc. dont continue playing
    this.modalBodySlotTarget.innerHTML = ''
  }
}

const querySelectorAllIncludingSelf = (element, query) =>
  [element, ...element.querySelectorAll(query)].filter((el) =>
    el.matches(query)
  )
